var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconionicMdAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 74.833,
    viewBox: "0 0 80 74.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-analytics",
    "data-name": "Icon ionic-md-analytics",
    transform: "translate(-2.25 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M64.272,13.446,48.7,37.262a8.481,8.481,0,0,1,1.928,5.41,8.57,8.57,0,0,1-17.139,0,9.391,9.391,0,0,1,.143-1.589L23.352,35.1a8.517,8.517,0,0,1-5.945,2.392,8.617,8.617,0,0,1-4.213-1.107L2.25,46.635V56.847A7.642,7.642,0,0,0,9.873,64.47H74.627a7.642,7.642,0,0,0,7.623-7.623V18.891L71.788,11.946a8.524,8.524,0,0,1-5.249,1.8A8.582,8.582,0,0,1,64.272,13.446Z",
    transform: "translate(0 13.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M17.429,33.554A8.574,8.574,0,0,1,26,42.125c0,.375-.036.75-.071,1.107l10.732,6A8.5,8.5,0,0,1,42.089,47.3a8.969,8.969,0,0,1,1.857.2L59.554,23.321a8.481,8.481,0,0,1-1.589-4.964,8.571,8.571,0,1,1,17.143,0,9.315,9.315,0,0,1-.232,2.018L82.25,25.3V11a7.644,7.644,0,0,0-7.625-7.625H9.875A7.644,7.644,0,0,0,2.25,11V51.946l7.143-6.839a8.571,8.571,0,0,1,8.036-11.554Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicMdAnalytics);
export default __webpack_public_path__ + "static/media/Icon ionic-md-analytics.787dd536a7e0ffcbc3e5591fafe6a68b.svg";
export { ForwardRef as ReactComponent };